import { render, staticRenderFns } from "./MamWalletView.vue?vue&type=template&id=49cd9d0c"
import script from "./MamWalletView.vue?vue&type=script&lang=js"
export * from "./MamWalletView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports